export interface PriceCatalogItem {
  id: number | string;
  [key: string]: unknown;
}

export interface PriceCatalogState {
  listLoading: boolean;
  pageCount: number;
  currentPageNumber: number;
  entities: PriceCatalogItem[] | null;
  totalResult: number;
  error: string | null;
}

export interface PriceCatalogPayload {
  totalPageCount: number;
  currentPageNumber: number;
  list: PriceCatalogItem[];
  totalResultCount: number;
}

const defaultState: PriceCatalogState = {
  listLoading: false,
  pageCount: 0,
  currentPageNumber: 0,
  entities: null,
  totalResult: 0,
  error: null,
};

export const actionTypes = {
  priceCatalogFetched: 'PRICE_CATALOG_FETCHED',
  priceCatalogAppended: 'PRICE_CATALOG_APPENDED',
  catchError: 'CATCH_ERROR',
} as const;

type PriceCatalogFetchedAction = {
  type: typeof actionTypes.priceCatalogFetched;
  payload: PriceCatalogPayload;
};

type PriceCatalogAppendedAction = {
  type: typeof actionTypes.priceCatalogAppended;
  payload: PriceCatalogPayload;
};

type CatchErrorAction = {
  type: typeof actionTypes.catchError;
  payload: { error: string };
};

type PriceCatalogAction =
  | PriceCatalogFetchedAction
  | PriceCatalogAppendedAction
  | CatchErrorAction;

export const popupPriceCatalogTableReducer = (
  state: PriceCatalogState = defaultState,
  action: PriceCatalogAction
): PriceCatalogState => {
  switch (action.type) {
    case actionTypes.priceCatalogFetched: {
      const { totalPageCount, currentPageNumber, list, totalResultCount } = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber,
        entities: list,
        totalResult: totalResultCount,
        error: null,
      };
    }
    case actionTypes.priceCatalogAppended: {
      const { totalPageCount, currentPageNumber, list, totalResultCount } = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber,
        entities: state.entities
          ? [...state.entities, ...list]
          : [...list],
        totalResult: totalResultCount,
        error: null,
      };
    }
    case actionTypes.catchError: {
      const error = `PRICE_CATALOG: ${action.payload.error}`;
      return { ...state, error };
    }
    default:
      return state;
  }
};

export const actions = {
  priceCatalogFetched: (data: PriceCatalogPayload): PriceCatalogFetchedAction => ({
    type: actionTypes.priceCatalogFetched,
    payload: data,
  }),
  priceCatalogAppended: (data: PriceCatalogPayload): PriceCatalogAppendedAction => ({
    type: actionTypes.priceCatalogAppended,
    payload: data,
  }),
  catchError: (error: string): CatchErrorAction => ({
    type: actionTypes.catchError,
    payload: { error },
  }),
};